export {
  ORDER_DETAIL_V2_ASSETS,
  ORDER_DETAIL_V2_URLS,
  ORDER_STATUS,
} from "./orderDetailV2.constants";
export type { OrderStatus } from "./orderDetailV2.constants";
